import cn from 'classnames';
import type { CalendarMode } from '../types';
import styles from './row-spacer.module.css';

type Properties = {
  days: Date[];
  mode: CalendarMode;
  orderedTimezones: string[];
};

const RowSpacer = ({ days, mode, orderedTimezones }: Properties) => (
  <div className={styles['row-spacer']}>
    {orderedTimezones.map((tz) => (
      <div className={styles['time-col']} key={tz} />
    ))}
    <div className={cn({ [styles['week-grid'] ?? '']: mode === 'week' })}>
      {days.map((d) => (
        <div key={d.toISOString()} />
      ))}
    </div>
  </div>
);

export default RowSpacer;
